module.exports = __webpack_public_path__ + "img/map_en.bb50ee2.png";